const ua = window.navigator.userAgent;

const base = {
  isIos: /iphone|ipad/i.test(ua),
  isAndroid: /android/i.test(ua),
  isChrome: /chrome/i.test(ua),
  isSafari: /safari/i.test(ua),
  /* 微信环境，包含微信浏览器和小程序浏览器 */
  isWechat: /MicroMessenger/i.test(ua),
  /* 微信环境，仅微信浏览器，不包含小程序内嵌webview */
  isWechatPure: /MicroMessenger/i.test(ua) && /miniProgram/i.test(ua) === false,
  /* 微信环境，仅包含小程序内嵌webview，，不包含微信浏览器 */
  isWechatMiniProgram: /MicroMessenger/i.test(ua) && /miniProgram/i.test(ua),
  /** 医联 App 环境 */
  isApp: /medlinker/i.test(ua),
  /** 小度 环境 */
  isXiaodu: /APP\/BaiduIhuHealthXiaodu/i.test(ua),
  /** 运行 环境 */
  appEnv: process.env.MED_APP_ENV as 'dev' | 'qa' | 'prod',
  /** 编译 环境（基座） */
  nodeEnv: process.env.NODE_ENV as 'development' | 'production',
  /** 观心环境 */
  isGuanxin: /Mobio/i.test(ua),
  /** 辅助角色 App 环境 */
  isAssistApp: /medlinkerAssist/i.test(ua),
  /** 爱康项目导医通App环境 */
  isDaoYiTongApp: /daoyitong/i.test(ua),
  /** 医联健康app环境 */
  isMedApp: /med_hybrid_medlinkerHealth/i.test(ua),
  swimlane: process.env.MED_SWIMLANE || '',
  /** 骨医生app */
  isOrthopedicsApp: /orthopaedicsApp/i.test(ua),
  /** 糖尿病app */
  isDiabetesApp: /diabetesApp/i.test(ua),
  medlinkerMedgptApp: /medlinker medgpt/i.test(ua),
  /** 医联小程序环境 */
  rmhysApp: /(android|ios)_doctor$/.test(ua),
  // 是否支付宝环境
  isAlipay: /AliPayClient/i.test(ua),
  // medgpt
  isMedgptApp: /medgpt/i.test(ua),
  // QQ浏览器
  isQQBrowser: /mqqbrowser/i.test(ua) && !/qq\//i.test(ua),
};

export function parseUA() {
  const ua = window.navigator.userAgent;

  return {
    isGuanxin: /Mobio/i.test(ua),
  };
}

export const getIosVersion = () => {
  const str = navigator.userAgent.toLowerCase();
  const ver = str.match(/cpu iphone os (.*?) like mac os/);

  if (!ver) {
    return false;
  }

  // console.log(`你当前的Ios系统版本为：${ver[1].replace(/_/g, '.')}`)
  return ver[1].replace(/_/g, '.');
};

const source = { ...process.env };

// @ts-ignore
delete source.NODE_ENV;
delete source.MED_PUBLIC_URL;

export default {
  ...base,
  getIosVersion,
  isThirdPlatform: base.isWechat,
  source,
};
